import { BaseQuery4 } from '@/utils';

/**
 * @startDate
 * @endDate
 * @scanSite
 * @destinationSites
*/
export const TableQuery = params => {
  const { scanProvinceArea, scanSite, receiveSite, destinationSite } = params;
  const arr = []
  scanProvinceArea && arr.push({key: 'scanProvinceArea', value: scanProvinceArea});
  scanSite && arr.push({key: 'scanSite', value: scanSite});
  receiveSite && arr.push({key: 'receiveSite', value: receiveSite});
  destinationSite && arr.push({key: 'destinationSite', value: destinationSite});
  return [
    {
      // 获取接货网点
      simpleGranularity: 'all',
      dataSource: 'opt_stock_site_waybill_result',
      dimensions: ['receiveSite', 'scanProvinceArea', 'destinationSite', 'scanSite'],
      startDate: params.startDate,
      endDate: params.endDate,
      aggregators: BaseQuery4(),
      andFilters: arr,
    },
    // 一派留仓
    [
      {
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite', 'leaveTime', 'scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [{key: 'type', value: '一派留仓'}],
        inFilters: [
          { key: 'destinationSite', value: params.destinationSites },
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
      {
        // 优势产品
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [
          {key: 'type', value: '一派留仓'},
          {key: 'superiorityProduct', value: '是'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
      {
        // 定时达
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [
          {key: 'type', value: '一派留仓'},
          {key: 'productType', value: '定时达'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
    ],
    // 二派留仓
    [
      {
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite', 'leaveTime', 'scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [{key: 'type', value: '二派留仓'}],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
      {
        // 优势产品
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [
          {key: 'type', value: '二派留仓'},
          {key: 'superiorityProduct', value: '是'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
      {
        // 定时达
        simpleGranularity: 'all',
        dataSource: 'opt_stock_site_waybill_result',
        dimensions: ['destinationSite','scanSite'],
        startDate: params.startDate,
        endDate: params.endDate,
        aggregators: BaseQuery4(),
        andFilters: [
          {key: 'type', value: '二派留仓'},
          {key: 'productType', value: '定时达'}
        ],
        inFilters: [
          {key: 'destinationSite', value: params.destinationSites},
        ],
        boundFilters: [
          {
            "dimension": "piece",
            "lowerValue": 1,
            "lowerEq": false,
          }
        ]
      },
    ]
  ]
}
